import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { FaArrowCircleLeft,FaArrowCircleRight } from "react-icons/fa";

import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import images from the assets folder
import Image1 from "../../../Assets/web1.png";
import Image2 from "../../../Assets/web2.png";
import Image3 from "../../../Assets/web3.png";

const sliderContent = [
  { image: Image1 },
  { image: Image2},
  { image: Image3},
];
const Slider = () => {
  const handleImageClick = (e) => {
    e.stopPropagation(); // Prevent slide change when clicking on the image
  };

  return (
    <div className="relative w-full  mx-auto">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        
        navigation={{
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        }}
        effect="fade"
        loop={true}
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        className="mySwiper"
        fadeEffect={{
          crossFade: true,
        }}
        speed={1000}
      >
        {sliderContent.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full lg:h-[31.8rem] h-[20rem]">
              <img
                src={slide.image}
                alt={`Slide ${index}`}
                className="w-full h-full object-cover cursor-pointer"
                onClick={handleImageClick}
              />
              
            </div>
          </SwiperSlide>
        ))}
        <div className=" text-white font-bold text-xl hover:text-richblack-800 hover:font-bold absolute top-1/2 left-4 transform -translate-y-1/2 w-12 h-12 border-2 border-white rounded-full flex items-center justify-center cursor-pointer hover:bg-white  z-10">
          <FaArrowCircleLeft />
        </div>
        <div className="swiper-button-next-custom text-white font-bold text-xl absolute hover:text-richblack-800 hover:font-bold top-1/2 right-4 transform -translate-y-1/2 w-12 h-12 border-2 border-white rounded-full flex items-center justify-center cursor-pointer hover:bg-white  z-10">
        <FaArrowCircleRight />
        </div>
      </Swiper>
    </div>
  );
};

export default Slider;
